import * as React from 'react';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { getBundleProductTitle } from '../../../../utils/get-bundle-product-title.js';
import ConfigurationSummaryRow from '../ConfigurationSummaryRow/ConfigurationSummaryRow.js';
import { FrameImage } from '../FrameImage/FrameImage.js';
import FrameInformation from '../FrameInformation/FrameInformationContainer.js';
import { PrescriptionUploadSummaryContainer } from '../PrescriptionUploadSummary/PrescriptionUploadSummaryContainer.js';
import PrescriptionSummary from '../PrescriptionSummary/PrescriptionSummaryContainer.js';

const DesktopConfigurationSummary = ({ labels , bundlePrice , frame , addOn , lensType , lensPackage , isPhone , hasVisitedStepPrescription , hasVisitedStepLensPackage , hasVisitedStepAddOn , prescriptionType ,  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: "desktop-configuration-summary"
    }, /*#__PURE__*/ React.createElement(FrameImage, null), frame && /*#__PURE__*/ React.createElement(ConfigurationSummaryRow, {
        className: "desktop-configuration-summary__frame-row",
        zeroPriceLabel: labels.zeroPrice,
        label: /*#__PURE__*/ React.createElement(FrameInformation, {
            textHeadingVariant: "smallest",
            showImage: isPhone,
            textOrientation: "vertical"
        }),
        price: frame.price
    }), /*#__PURE__*/ React.createElement("div", {
        className: "desktop-configuration-summary__selections"
    }, lensType && /*#__PURE__*/ React.createElement(ConfigurationSummaryRow, {
        zeroPriceLabel: labels.zeroPrice,
        label: labels.lensType,
        value: getBundleProductTitle(lensType),
        price: lensType.price,
        discountText: lensType.discountText
    }), hasVisitedStepLensPackage && lensPackage && /*#__PURE__*/ React.createElement(ConfigurationSummaryRow, {
        zeroPriceLabel: labels.zeroPrice,
        label: labels.lensPackage,
        value: lensPackage.title,
        price: lensPackage.price,
        discountText: lensPackage.discountText
    }), hasVisitedStepAddOn && addOn && /*#__PURE__*/ React.createElement(ConfigurationSummaryRow, {
        zeroPriceLabel: labels.zeroPrice,
        label: labels.addOn,
        value: getBundleProductTitle(addOn),
        price: addOn.price,
        discountText: addOn.discountText
    }), /*#__PURE__*/ React.createElement(ConfigurationSummaryRow, {
        zeroPriceLabel: labels.zeroPrice,
        label: labels.totalPrice,
        price: bundlePrice,
        priceSize: "medium"
    })), hasVisitedStepPrescription ? /*#__PURE__*/ React.createElement("div", {
        className: "desktop-configuration-summary__prescription"
    }, CommerceToolsApi.isPrescriptionFile(prescriptionType) ? /*#__PURE__*/ React.createElement(PrescriptionUploadSummaryContainer, {
        hideDividers: true
    }) : /*#__PURE__*/ React.createElement(PrescriptionSummary, null)) : null);
};
var DesktopConfigurationSummary$1 = DesktopConfigurationSummary;

export { DesktopConfigurationSummary$1 as default };
//# sourceMappingURL=DesktopConfigurationSummary.js.map
